import * as api from '@gitbook/api-client';
import { Description, FieldGroup, Label, TilePicker } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';
import backgroundDefaultDarkImage from './assets/sidebar-background-default-dark.svg';
import backgroundDefaultLightImage from './assets/sidebar-background-default-light.svg';
import backgroundFilledDarkImage from './assets/sidebar-background-filled-dark.svg';
import backgroundFilledLightImage from './assets/sidebar-background-filled-light.svg';

/**
 * Settings to configure the style of the sidebar background
 */
export function SidebarBackgroundStyleSetting(props: SitesCustomizationPanelProps) {
    const { settings, setSettings } = props;

    return (
        <>
            <FieldGroup>
                <Label>Background style</Label>
                <Description>Choose the background style for the sidebar container</Description>
            </FieldGroup>
            <TilePicker
                aria-label="Background style"
                items={BACKGROUND_STYLE_OPTIONS}
                selectedItem={settings.styling.sidebar.background}
                setSelectedItem={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        styling: {
                            ...prev.styling,
                            sidebar: {
                                ...prev.styling?.sidebar,
                                background: value,
                            },
                        },
                    }));
                }}
            />
        </>
    );
}

const BACKGROUND_STYLE_OPTIONS = [
    {
        value: api.CustomizationSidebarBackgroundStyle.Default,
        label: 'Default',
        asset: {
            light: backgroundDefaultLightImage,
            dark: backgroundDefaultDarkImage,
        },
    },
    {
        value: api.CustomizationSidebarBackgroundStyle.Filled,
        label: 'Filled',
        asset: {
            light: backgroundFilledLightImage,
            dark: backgroundFilledDarkImage,
        },
    },
];
